<div mat-dialog-title class="flex flex-row">
    Turmas Disponíveis 
    <div class="flex-fill"></div>
    <div class="btn-options">
        <button color="primary" (click)="dialogRef.close()" mat-icon-button matTooltip="Fechar">
            <mat-icon>close</mat-icon>
        </button>
    </div>
</div>
<div mat-dialog-content>
    <div class="loading-shade" *ngIf="isLoadingResults">
        <mat-spinner></mat-spinner>
    </div>
    <div *ngIf="!error;else errorTemplate">
        <form [formGroup]="form">
            <div class="flex form-registro">
                <mat-form-field *ngIf="cursos; else loading">
                    <mat-label>Curso</mat-label>
                    <mat-select formControlName="cursoId">
                        <mat-option *ngFor="let curso of cursos" [value]="curso.id">
                            {{ curso.descricao }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </form>

        <div class="table">
            <table mat-table [dataSource]="dataSource">
                <ng-container matColumnDef="unidade">
                    <th mat-header-cell *matHeaderCellDef> Unidade </th>
                    <td mat-cell *matCellDef="let element"> {{ ajustarUnidade(element?.unidade) }} </td>
                </ng-container>

                <ng-container matColumnDef="curso">
                    <th mat-header-cell *matHeaderCellDef> Curso </th>
                    <td mat-cell *matCellDef="let element"> {{ ajustarCurso(element?.curso) }} </td>
                </ng-container>

                <ng-container matColumnDef="presencial">
                    <th mat-header-cell *matHeaderCellDef> Modalidade </th>
                    <td mat-cell *matCellDef="let element"> {{element.presencial ? 'Presencial' : 'Distância'}} </td>
                </ng-container>

                <ng-container matColumnDef="ano">
                    <th mat-header-cell *matHeaderCellDef class="sm-column"> Ano </th>
                    <td mat-cell *matCellDef="let element"> {{element.ano ? element.ano : '-'}} </td>
                </ng-container>

                <ng-container matColumnDef="semestre">
                    <th mat-header-cell *matHeaderCellDef> Vigência </th>
                    <td mat-cell *matCellDef="let element"> {{ ajustarVigencia(element?.semestre) }} </td>
                </ng-container>

                <ng-container matColumnDef="diaSemana">
                    <th mat-header-cell *matHeaderCellDef> Dia da Semana </th>
                    <td mat-cell *matCellDef="let element">
                        {{ ajustarDiaDaSemana({
                            Seg: element?.segunda,
                            Ter: element?.terca,
                            Qua: element?.quarta,
                            Qui: element?.quinta,
                            Sex: element?.sexta,
                            Sab: element?.sabado,
                            Dom: element?.domingo
                        })}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="periodo">
                    <th mat-header-cell *matHeaderCellDef> Período </th>
                    <td mat-cell *matCellDef="let element"> {{ ajustarPeriodo(element?.periodo) }} </td>
                </ng-container>

                <ng-container matColumnDef="horario">
                    <th mat-header-cell *matHeaderCellDef> Horário </th>
                    <td mat-cell *matCellDef="let element"> {{ ajustarHorario(element?.horarioInicio, element?.horarioTermino) }} </td>
                </ng-container>

                <ng-container matColumnDef="sala">
                    <th mat-header-cell *matHeaderCellDef> Sala </th>
                    <td mat-cell *matCellDef="let element"> {{element?.sala ? element.sala : '-'}} </td>
                </ng-container>

                <ng-container matColumnDef="disponivel">
                    <th mat-header-cell *matHeaderCellDef> Disponível </th>
                    <td mat-cell *matCellDef="let element"> {{element?.disponivel ? 'Sim' : 'Não'}} </td>
                </ng-container>

                <ng-container matColumnDef="quantidadeVagas">
                    <th mat-header-cell *matHeaderCellDef> Vagas </th>
                    <td mat-cell *matCellDef="let element"> {{(element?.quantidadeVagas && element.presencial) ? element.quantidadeVagas : '-'}} </td>
                </ng-container>

                <ng-container matColumnDef="options">
                    <th mat-header-cell *matHeaderCellDef> </th>
                    <td mat-cell *matCellDef="let element"> 
                        <div class="btn-options">
                            <button [disabled]="!element?.quantidadeVagas && element.presencial" (click)="close(element)" color="primary" mat-icon-button matTooltip="Vincular">
                                <mat-icon>how_to_reg</mat-icon>
                            </button>
                         </div>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"
                    (click)="selection.toggle(row)" [ngClass]="{ 'selected': selection.isSelected(row) }"></tr>
            </table>
        </div>
    </div>
</div>

<ng-template #errorTemplate>
    <app-server-error></app-server-error>
</ng-template>

<ng-template #loading>
    <mat-spinner [diameter]="25"></mat-spinner>
</ng-template>